import React from 'react'
import { NextPage } from 'next'
import { ArticleDirectoryPage } from 'experiences/learn/articles/ArticleDirectory'
import { PagePropsWrapper, SEOFriendlyInitialProps } from 'lib/routing/nextPageUtils'
import { Article } from 'services/ContentfulService/models/articles'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { BasicCrossSell } from 'components/layout'
import { FionaProducts } from 'parameters/general'
import { fetchArticles } from 'services/ContentfulService/hooks/articles'
import { BLOCKS } from '@contentful/rich-text-types'

interface Props {
	articles: Article[]
	pageCount?: number
}

const PAGE_SIZE = 7

const LearnArticles: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => {
	const dividers: JSX.Element[] = [
		<BasicCrossSell key={'loans'} product={FionaProducts.Loans} />,
		<BasicCrossSell key={'ins'} product={FionaProducts.LifeInsurance} />
	]
	return (
		<StandardLayout metaTags={metaTags}>
			<ArticleDirectoryPage
				initialArticles={pageProps.articles}
				initialPage={pageProps.pageCount}
				dividers={dividers}
			/>
		</StandardLayout>
	)
}

// TODO: Migrate to SSR props and strip out content from article load
LearnArticles.getInitialProps = SEOFriendlyInitialProps<Props>(
	async ctx => {
		let pageCount: number | undefined
		try {
			pageCount = parseInt(ctx.query.page as string)
		} catch (e) {}

		const initialArticlesInput = {
			constraints: [],
			include: 0,
			count: PAGE_SIZE,
			offset: (pageCount || 0) * PAGE_SIZE
		}

		const articles = await fetchArticles(initialArticlesInput)
		articles.forEach(article => (article.content = { content: [], data: {}, nodeType: BLOCKS.DOCUMENT }))
		return {
			articles,
			pageCount: pageCount
		}
	},
	metadataTags => {
		return { ...metadataTags, title: 'Fiona Articles' }
	},
	'/learn/articles'
)

export default LearnArticles
